import {fromJS, Map} from 'immutable';
import lifetimePlaysActions from '../../actions/fortnite-game/lifetimePlays.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {TimeScale} from '../../types';

export interface LifetimePlaysDataItem {
    creativeAccountId: string;
    creativeIslandCode: string;
    value: number;
}

const DEFAULT_DATA = {
    [TimeScale.DAILY]: {
        list: [],
        empty: [],
        overallVisits: 0,
        mostVisited: {
            value: 0,
            creativeIslandCode: null
        }
    }
};

export const DEFAULT_STATE = fromJS({
    data: DEFAULT_DATA,
    timeScale: TimeScale.DAILY,
    lastFetch: Date.now(),
    error: undefined,
    loading: false
});

export const lifetimePlaysReducer = (state: Map<string, any> = DEFAULT_STATE, action) => {
    const {timeScale, data, silent = false, error} = action.payload || {};

    switch (action.type) {
        case lifetimePlaysActions.TYPES.GET_LIFETIME_PLAYS: {
            return state.merge({
                timeScale,
                error: undefined,
                loading: !silent
            });
        }

        case lifetimePlaysActions.TYPES.GET_LIFETIME_PLAYS_COMPLETE: {
            return state
                .update('data', stateData => stateData.set(state.get('timeScale'), data))
                .merge({
                    lastFetch: Date.now(),
                    loading: false,
                    error
                });
        }

        case lifetimePlaysActions.TYPES.GET_LIFETIME_PLAYS_FAILED: {
            return state.merge({
                error,
                loading: false
            });
        }

        case lifetimePlaysActions.TYPES.RESET_DATA: {
            return state.merge({
                data: DEFAULT_DATA
            });
        }

        default:
            return state;
    }
};

export default dieselReducer('lifetimePlays', lifetimePlaysReducer);
